import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthGate } from "../../contexts/AuthGateContext";
import Favicon from "../../assets/favicon-32x32.png";
import { HiXMark } from "react-icons/hi2";

const reasonText = (reason) => {
  switch (reason) {
    case "follow":
      return "Sign in to follow and connect with people.";
    case "like":
      return "Sign in to like posts and show your appreciation.";
    case "request_access":
      return "Sign in to request access to this profile.";
    case "view_private_profile":
      return "Sign in to view this private profile.";
    case "view_profile":
      return "Sign in to interact with this profile, follow users, like posts, and more.";
    default:
      return "Sign in to continue.";
  }
};

const AuthGateModal = () => {
  const { authGate, closeAuthGate } = useAuthGate();
  const navigate = useNavigate();
  const location = useLocation();

  const isOpen = authGate?.isOpen === true;
  const redirectTo = useMemo(() => authGate?.redirectTo || location.pathname, [authGate?.redirectTo, location.pathname]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={() => closeAuthGate()}
      />
      <div className="relative w-[92%] max-w-lg rounded-xl bg-white shadow-xl border border-gray-200 p-6">
        {/* Close button - top right */}
        <button
          type="button"
          onClick={() => closeAuthGate()}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <HiXMark className="w-6 h-6" />
        </button>

        {/* Centered logo/avatar */}
        <div className="flex flex-col items-center pt-2">
          <img
            src={Favicon}
            alt="SkillConnect"
            className="w-20 h-20 mb-4"
          />
          
          {/* Title */}
          <h3 className="text-xl font-semibold text-gray-900 font-flex-regular mb-2">
            Join on SkillConnect
          </h3>
          
          {/* Description */}
          <p className="text-sm text-gray-600 text-center font-flex-regular mb-6">
            {reasonText(authGate?.reason)}
          </p>

          {/* Sign In button */}
          <button
            type="button"
            onClick={() => {
              closeAuthGate();
              navigate("/auth", { state: { from: redirectTo } });
            }}
            className="px-6 py-2.5 rounded-lg bg-primary-600 text-white hover:bg-primary-700 text-sm font-medium transition-colors"
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthGateModal;

